import React, { Component } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { fetchFolderContent } from "apps/simplified-web/src/_actions/folderActions"
import { ImageItem, ImageItemWithoutDrag, ShowCenterSpinner } from "../../../common/statelessView";
import TLDRInfiniteGalleryGridLayout from "../../../common/TLDRInfiniteGalleryGridLayout";
import { getFabricTypeFromMime } from "apps/simplified-web/src/_utils/common";
import StoryCard from "../../../home/StoryCard";
import { TAB_MY_FOLDERS } from "../../constants";
import AIDocument from "../../../../TldrAi/AIDocument";
import { Center, Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

const subtitleStyles = {
  color: "brand.white",
  fontSize: "1.125rem",
  fontWeight: "500",
  fontSize: "1rem",
  marginBottom: "2",
  marginLeft: "6",
}

class FolderContentsView extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      content: [],
      page: 1,
      hasMoreContent: false,
    }
  }

  componentDidMount() {
    this.fetchContent()
  }

  fetchContent = () => {
    const { folder } = this.props;
    const { page, content } = this.state;

    this.props.fetchFolderContent(folder.id, folder.organization, page, this.signal.token)
      .then((res) => {
        this.setState({
          loaded: true,
          content: [...content, ...res.results],
          hasMoreContent: res.next !== null,
          page: res.next !== null ? page + 1 : 1,
        })
      })
      .catch(() => {
        this.setState({
          loaded: true,
          content: [],
        })
      });
  }

  prepareUserAssetPayload = (asset) => {
    asset.thumbnail_width = asset.thumbnail_width || 200;
    asset.thumbnail_height = asset.thumbnail_height || 200;

    const message = {
      mime: asset.asset_type,
      type: asset.asset_type === "shape" ? "icon" : asset.asset_type,
      payload: {
        name: asset.asset_key || "New Asset",
        src: asset.thumbnail,
        type: getFabricTypeFromMime(asset.asset_type),
        height: asset.thumbnail_height,
        width: asset.thumbnail_width,
      },
      content: {
        meta: asset,
        url: asset.thumbnail,
      },
    };

    return message;
  }

  prepareTeamTemplatePayload = (data) => {
    const message = {
      mime: "shape",
      id: data.id,
      type: "component",
      content: {
        meta: {
          ...data,
        },
      },
    };
    return message;
  }

  addTemplateLayerCallback = (payload) => {
    if (this.props.onTemplateClick) {
      this.props.onTemplateClick(payload);
    }
  }

  addAssetLayerCallback = (payload) => {
    if (this.props.onAssetClick) {
      this.props.onAssetClick(payload);
    }
  }

  addProjectLayerCallback = (payload) => {
    if (this.props.onProjectClick) {
      this.props.onProjectClick(payload);
    }
  }

  loadPage = () => {
    this.fetchContent()
  }

  render() {
    const { loaded, content, hasMoreContent } = this.state;
    const {
      t,
      folder,
      isDragAndDropContextAvailable,
      storyCardTab,
    } = this.props;

    const childElements = content.map((asset) => {
      if (asset.hasOwnProperty("story_type") && !asset.hasOwnProperty("publish")) {
        return (
          <div
            key={asset.content_id}
            className="item"
            data-grid-groupkey={asset.groupKey || 1}
            onClick={() => {
              this.addProjectLayerCallback(asset);
            }}
          >
            <StoryCard
              story={asset}
              tab={storyCardTab}
              template={asset.template}
              enableCardSelection={false}
              showDownloadOption={false}
              onActionComplete={() => { }}
              currentFolderId={folder.id}
              showRemoveFromFolder={false}
              showExtraOptions={false}
            />
          </div>
        );
      } else if (asset.hasOwnProperty("story_type") && asset.hasOwnProperty("publish")) {
        const payload = this.prepareTeamTemplatePayload(asset);

        return (
          <div
            key={`${asset.id}_${Date.now()}`}
            className="item item-folder-template"
            onClick={() => {
              this.addTemplateLayerCallback(payload);
            }}
            data-grid-groupkey={asset.groupKey || 1}
          >
            {isDragAndDropContextAvailable ? (
              <ImageItem
                data={payload}
                key={asset.id}
                url={payload.content?.meta.image}
                alt={asset.description}
                width={asset.image_width}
                height={asset.image_width}
                hasAction={false}
                itemWidth={81}
                modalFor={""}
                type={"svg"}
              />
            ) : (
              <ImageItemWithoutDrag
                data={payload}
                key={asset.id}
                url={payload.content?.meta.image}
                alt={asset.description}
                width={asset.image_width}
                height={asset.image_width}
                hasAction={false}
                itemWidth={81}
                modalFor={""}
                type={"svg"}
              />
            )}
          </div>
        );
      } else if (asset.hasOwnProperty("asset_type")) {
        const payload = this.prepareUserAssetPayload(asset);

        return (
          <div
            key={`${asset.id}_${Date.now()}`}
            className="item item-asset"
            onClick={() => {
              if (asset.asset_type !== "audio") this.addAssetLayerCallback(payload);
            }}
            data-grid-groupkey={asset.groupKey || 1}
          >
            {isDragAndDropContextAvailable ? (
              <ImageItem
                data={payload}
                key={asset.id}
                url={
                  asset.thumbnail_cover_image
                    ? asset.thumbnail_cover_image
                    : asset.thumbnail
                }
                alt={"asset"}
                width={asset.cover_image_width || 200}
                height={asset.cover_image_height || 200}
                source={"Simplified"}
                hasAction={false}
                type={"asset"}
                modalFor={"asset"}
                showOverlayInfo={false}
                isUsedInSwiper={false}
              />
            ) : (
              <ImageItemWithoutDrag
                data={payload}
                key={asset.id}
                url={
                  asset.thumbnail_cover_image
                    ? asset.thumbnail_cover_image
                    : asset.thumbnail
                }
                alt={"asset"}
                width={asset.cover_image_width || 200}
                height={asset.cover_image_height || 200}
                source={"Simplified"}
                hasAction={false}
                type={"asset"}
                modalFor={"asset"}
                showOverlayInfo={false}
                isUsedInSwiper={false}
              />
            )}
          </div>
        );
      } else if (asset.hasOwnProperty("doc_type")) {
        return (
          <div
            key={`${asset.id}_${Date.now()}`}
            className="item"
            data-grid-groupkey={asset.groupKey || 1}
          >
            <AIDocument
              result={asset}
              enableCardSelection={false}
              onActionComplete={() => { }}
              currentFolderId={folder.id}
              showRemoveFromFolder={false}
            ></AIDocument>
          </div>
        );
      } else {
        return <></>;
      }
    });

    return (
      <>
        {!loaded ? (
          <ShowCenterSpinner loaded={loaded}></ShowCenterSpinner>
        ) : loaded && content.length > 0 ? (
          <>
            <TLDRInfiniteGalleryGridLayout
              hasMore={hasMoreContent}
              loadPage={this.loadPage}
              className="asset-gallery"
              loaded={loaded}
            >
              {childElements}
            </TLDRInfiniteGalleryGridLayout>
          </>
        ) : loaded && content.length === 0 ? (
          <Center flex='1'>
            <Text textAlign="center" color="gray.200">
              {t("assets.nothing_here")}
            </Text>
          </Center>
        ) : null}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  foldersPage: state.folders.foldersPage,
  activePage: state.editor.activePage,
})

const mapDispatchToProps = (dispatch) => ({
  fetchFolderContent: (id, org, page, signalToken) => dispatch(fetchFolderContent(id, org, page, signalToken)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(["folders"])(FolderContentsView))